export default "__VITE_ASSET__xvXwCCO8__"